// @ts-nocheck

import { isEqual } from 'lodash';
import { createSelectorCreator, defaultMemoize } from 'reselect';

import shallowEqual from '../lib/core/shallowEqual';

export const createResultEqualSelector = createSelectorCreator(defaultMemoize, { resultEqualityCheck: isEqual });
export const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);
export const createShallowEqualSelector = createSelectorCreator(defaultMemoize, shallowEqual);

export default {
  createResultEqualSelector,
  createDeepEqualSelector,
  createShallowEqualSelector,
};
